import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { DeliveryMethodStatisticModel } from '../../models/delivery-method-statistic-model';
import { SecuritySummaryModel } from '../../models/security-summary.model';
import { ShareholderTypeModel } from '../../models/shareholder-type.model';
import { StatisticsItemModel } from '../../models/statistics-item.model';

@Injectable({
    providedIn: 'root'
})
export class StatisticsResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'statistics' }));
    }

    /**
     * Gets a list of shareholders with paging and filtering options.
     */
    getShareDistribution(): Observable<ApiResponseModel<StatisticsItemModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel[]>>(this.getUrl('shares/distribution'));
    }

    getTotalShareholders(): Observable<ApiResponseModel<StatisticsItemModel>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel>>(this.getUrl('shareholders/count'));
    }

    getShareholderTypes(): Observable<ApiResponseModel<ShareholderTypeModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<ShareholderTypeModel[]>>(this.getUrl('shareholders/types'));
    }

    getTotalDispo(): Observable<ApiResponseModel<StatisticsItemModel>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel>>(this.getUrl('shares/dispo-sum'));
    }

    getTotalDispoPercent(): Observable<ApiResponseModel<StatisticsItemModel>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel>>(this.getUrl('shares/dispo-sum-percent'));
    }

    getTotalRegistered(): Observable<ApiResponseModel<StatisticsItemModel>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel>>(this.getUrl('shares/registered-sum'));
    }

    getTotalRegisteredPercent(): Observable<ApiResponseModel<StatisticsItemModel>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel>>(this.getUrl('shares/registered-sum-percent'));
    }

    getSecurities(): Observable<ApiResponseModel<SecuritySummaryModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<SecuritySummaryModel[]>>(this.getUrl('securities'));
    }

    getDomicile(): Observable<ApiResponseModel<StatisticsItemModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<StatisticsItemModel[]>>(this.getUrl('shareholders/domicile'));
    }

    getDeliveryMethods(): Observable<ApiResponseModel<DeliveryMethodStatisticModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<DeliveryMethodStatisticModel[]>>(this.getUrl('shareholders/delivery-methods'));
    }
}
